module.exports = __webpack_public_path__ + "img/ceshi.7cc88688.png";